import { api } from '../api.js';
import { isNetworkError, useOffline } from '../../stores/offline.js';
import { db, kvGet, kvSet } from './db.js';

/**
 * GET that falls back to the last good copy when the server can't be reached. Used for the
 * catalog, printers and settings so billing keeps working offline.
 */
export async function cachedGet(path, key) {
  try {
    const data = await api.get(path);
    useOffline.getState().reachable || useOffline.getState().set({ reachable: true });
    await kvSet(key, data);
    return data;
  } catch (err) {
    if (!isNetworkError(err)) throw err;
    useOffline.getState().set({ reachable: false });
    const cached = await kvGet(key);
    if (cached) return cached;
    throw err;
  }
}

/** Refresh the recent-customers cache (called after each sync). */
export async function refreshCustomers() {
  try {
    const r = await api.get('/sync/customers');
    await db.transaction('rw', db.customers, async () => {
      await db.customers.clear();
      await db.customers.bulkPut(r.items);
    });
  } catch {
    /* keep the old list */
  }
}

/** Phone lookup without internet (digits anywhere in the number). */
export async function searchCachedCustomers(digits) {
  try {
    const all = await db.customers.toArray();
    return all.filter((c) => c.phone.includes(digits)).slice(0, 8);
  } catch {
    return [];
  }
}

/** Remember a customer added offline so the next lookup finds them. */
export async function cacheCustomer(c) {
  try {
    await db.customers.put(c);
  } catch {
    /* ignore */
  }
}
